import React from "react";
import { useRouter } from "next/router";
import { Card, CardBody, CardHeader } from "reactstrap";

import ChooseServiceTable from "./choose-service-table";
import { AvailableRate } from "@/@types/Rating/AvailableRate";
import { routes } from "@/utils/routes";
import { getInstantQuotes } from "@/utils/content";
import ChooseServiceTop3 from "./choose-service-top-3";
import { getTop3Rates } from "@/utils/ratingUtils";
import useGoogleAnalytics from "@/hooks/useGoogleAnalytics";

interface ChooseServiceProps {
  availableRates: AvailableRate[];
  didInfoChanged: Boolean;
}
const ChooseService = ({
  didInfoChanged,
  availableRates,
}: ChooseServiceProps) => {
  const router = useRouter();
  const { sendCustomEvent } = useGoogleAnalytics();

  const handleChooseRate = () => {
    sendCustomEvent("shipNowGuest", {
      page: {
        url:
          document.location.origin +
          document.location.pathname +
          document.location.search,
      },
    });

    router.push(routes.register);
  };

  return (
    <div className="py-3">
      {didInfoChanged ? (
        <div className="text-center fs-5 text-primary">
          {getInstantQuotes.en.infoChangedLabel}
        </div>
      ) : (
        <Card className="my-5 rounded-0 shadow-lg">
          <CardHeader>Choose Carrier and Service</CardHeader>
          <CardBody>
            <ChooseServiceTop3
              top3Rates={getTop3Rates(availableRates)}
              handleChooseRate={handleChooseRate}
            />

            <ChooseServiceTable
              tableTitle={getInstantQuotes.en.chooseServiceTableTitle}
              availableRates={availableRates}
              handleChooseRate={handleChooseRate}
            />
          </CardBody>
        </Card>
      )}
    </div>
  );
};

export default ChooseService;
